import { persianLanguage } from '../constants/persianTerms';
import { numbersOnlyRegex } from "./regex-patterns";

export const checkInputIsInteger = (value) => {
    let result = {"value": value, "status": 200}
    const regexPattern = /^[0-9\b]+$/;
    if (regexPattern.test(value)) {
        result ={"value": value, "status": 200}
    } else {
        result =  {"value": value, "status": 401}
    }
    return result
}

export const mobileNumberValidation = (value) => {
    let result = {
        "value": value, 
        "status": 200, 
        "persianMessage": ""
    };
    if(value?.length > 0){
        if(!numbersOnlyRegex.test(value)){
            result["status"] = 400;
            result["value"] = null;
            result["persianMessage"] = persianLanguage.phrase.error.ERROR_MOBILE_NUMBER_WRONG_FORMAT;
            return result;
        } else if(value.length > 11){
            result["status"] = 400;
            result["value"] = null;
            result["persianMessage"] = persianLanguage.phrase.error.ERROR_MOBILE_NUMBER_WRONG_FORMAT;        
        } 
        else if(value[0] === "0" && value.length !== 11){
            result["status"] = 400;
            result["value"] = null;
            result["persianMessage"] = persianLanguage.phrase.error.ERROR_MOBILE_NUMBER_WRONG_FORMAT;
            return result;
        } else if(value[0] !== "0" && value.length === 11){
            result["status"] = 400;
            result["value"] = null;
            result["persianMessage"] = persianLanguage.phrase.error.ERROR_MOBILE_NUMBER_WRONG_FORMAT;
            return result;
        } else if(value[0] !== "9" && value.length === 10){
            result["status"] = 400;
            result["value"] = null;
            result["persianMessage"] = persianLanguage.phrase.error.ERROR_MOBILE_NUMBER_WRONG_FORMAT;
            return result;
        } else if(value.length === 10 && value[0] === "9"){
            result["value"] = "0" + value;
        }

    } else {
        result["status"] = 400
    }


    return result
}